import { useEffect, useState } from "react";

const useActiveSection = (sectionIds: string[]) => {
    const [activeId, setActiveId] = useState(sectionIds[0] ?? "");

    useEffect(() => {
        if (sectionIds.length === 0) return;

        const sections = sectionIds
            .map((id) => document.getElementById(id))
            .filter((section): section is HTMLElement => Boolean(section));

        if (sections.length === 0) return;

        const observer = new IntersectionObserver(
            (entries) => {
                const visibleEntries = entries.filter((entry) => entry.isIntersecting);
                if (visibleEntries.length === 0) return;

                const mostVisible = visibleEntries.sort(
                    (a, b) => b.intersectionRatio - a.intersectionRatio
                )[0];

                if (mostVisible?.target instanceof HTMLElement) {
                    setActiveId(mostVisible.target.id);
                }
            },
            {
                rootMargin: "-35% 0px -45% 0px",
                threshold: [0.1, 0.3, 0.5, 0.75],
            }
        );

        sections.forEach((section) => observer.observe(section));

        return () => observer.disconnect();
    }, [sectionIds]);

    return activeId;
};

export default useActiveSection;
